import {
  Component,
  OnInit,
  inject,
  ChangeDetectionStrategy,
} from '@angular/core';
import { AuthService } from 'src/app/services/auth.service';
import { ContactApiService } from 'src/app/services/api/contact-api.service';
import { take } from 'rxjs/operators';
import { TabService } from 'src/app/core/services/tab.service';
import { LogAndMessageService } from 'src/app/services/log-and-message.service';
import {
  CONTACT_DETAIL_CONTAINER,
  CONTACT_SEARCH_CONTAINER,
} from 'src/app/constants/common.constants';
import { DeviceService } from 'src/app/services/device.service';
import { ContactTableService } from 'src/app/services/table/contact-table.service';
import { Contact } from 'src/app/model/contacts/contact';
import { ProgressSpinnerComponent } from '../../../core/components/progress-spinner.component';
import { firstValueFrom } from 'rxjs';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-contact-profile-container',
  templateUrl: './contact-profile-container.component.html',
  styleUrls: ['./contact-profile-container.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [ProgressSpinnerComponent],
})
export class ContactProfileContainerComponent implements OnInit {
  protected _auth = inject(AuthService);
  protected _contactApi = inject(ContactApiService);
  protected _contactTable = inject(ContactTableService);
  protected _logger = inject(LogAndMessageService);
  protected _deviceService = inject(DeviceService);
  protected _tabService = inject(TabService);
  protected _translateService = inject(TranslateService);

  loading = false;

  async ngOnInit() {
    this.loading = true;
    const email = this._auth.getEmail();
    const label = await firstValueFrom(
      this._translateService.get('CONTACT.SCREEN.PROFILE')
    );
    this._tabService.updateActiveTabLabel(label);
    console.log('EMAIL: ' + email);
    if (email) {
      // lookup contact record via email query
      this._contactApi
        .getFullContactByEmail(email)
        .pipe(take(1))
        .subscribe({
          next: (contact) => {
            this._contactTable.setScreenEmbedded(true);
            this._contactTable.setSelected(contact);
            const id = contact?.id;
            const oldTab = this._tabService.getActiveTab();
            const newTab = this._tabService.buildNewTab(
              CONTACT_DETAIL_CONTAINER,
              true,
              'My Profile',
              id
            );
            if (this._deviceService.isMobile()) {
              this._tabService.setMobileTab(newTab);
            } else {
              this._tabService.replaceTab(oldTab, newTab);
            }
          },
          error: (error) => {
            console.error('Error getting contact by email.', error);
            this._logger.translateToErrorAlert({
              headerKey: 'CONTACT.MESSAGES.HEADERS.FAILED_GET_CONTACT',
              bodyKey: 'CONTACT.MESSAGES.ERROR.GET_CONTACT',
            });
            this._tabService.closeTab(this._tabService.getActiveIndex());
            this.loading = false;
          },
        });
    } else {
      this.loading = false;
      this._logger.errorLogOnly('email not found.');
      this._logger.translateToErrorAlert({
        headerKey: 'CONTACT.MESSAGES.HEADERS.FAILED_GET_CONTACT',
        bodyKey: 'CONTACT.MESSAGES.ERROR.GET_CONTACT',
      });
      if (this._deviceService.isMobile()) {
        const tab = this._tabService.buildNewTab(
          CONTACT_SEARCH_CONTAINER,
          true
        );
        this._tabService.setMobileTab(tab);
      } else {
        const index = this._tabService.getActiveIndex();
        this._tabService.closeTab(index);
      }
    }
  }
}
